import $ from 'jquery';
import { each } from 'lodash';
import 'smartmenus';
import 'smartmenus-keyboard';
import { gsap } from 'gsap';

export function MainMenu() {
  const mainNavID = 'main-navbar-nav';
  const navUl = document.querySelector('.main-nav ul');
  if (navUl) {
    navUl.setAttribute('id', mainNavID);
    $('#' + mainNavID).addClass('sm').smartmenus({
      mainMenuSubOffsetX: -1,
      subMenusSubOffsetX: 10,
      subMenusSubOffsetY: 0,
      subIndicators: false,
    });
  }
}

export function MobileNav() {
  const mobileNav = document.getElementById('mobile-nav');
  const mobileMenu = document.querySelector('#mobile-nav ul');
  const buttonOpen = document.getElementById('open-mobile-nav');
  const buttonClose = document.getElementById('close-mobile-nav');
  if (!mobileNav || !buttonOpen || !buttonClose) return;

  const toggleDropdown = (e) => {
    e.preventDefault();
    let element = e.target;
    if (!element) return;
    if (element.tagName === 'SPAN' && element.classList.contains('sub-arrow')) {
      const ul = element.parentNode.nextElementSibling;
      if (element.parentNode.getAttribute('aria-expanded') === 'false') {
        const height = element.parentNode.getAttribute('data-height');
        element.parentNode.setAttribute('aria-expanded', 'true');
        gsap.set(ul, { display: 'block' });
        gsap.to(ul, 0.25, {
          maxHeight: `${height}px`,
          ease: 'Power4.easeOut',
        });
      } else {
        element.parentNode.setAttribute('aria-expanded', 'false');
        gsap.to(ul, 0.25, {
          maxHeight: '0px',
          ease: 'Power4.easeOut',
          onComplete: () => {
            gsap.set(ul, { display: 'none' });
          },
        });
      }
    } else {
      if (element.tagName === 'SPAN') { element = element.parentNode; }
      const href = element.getAttribute('href');
      if (href && !element.classList.contains('disabled')) {
        window.location = href;
      }
    }
  };

  const keyCodeCheck = (e) => {
      if (!e.target) return;
      let keycode = e.code;
      if (keycode === "Space") {
         e.preventDefault();
         const ul = e.target.nextElementSibling;
         if (e.target.getAttribute('aria-expanded') === 'false') {
            e.target.setAttribute('aria-expanded', 'true');
            gsap.set(ul, { display: 'block' });
            gsap.to(ul, 0.25, {
              ease: 'Power4.easeOut',
            });
          } else {
            e.target.setAttribute('aria-expanded', 'false');
            gsap.to(ul, 0.25, {
              ease: 'Power4.easeOut',
              onComplete: () => {
                gsap.set(ul, { display: 'none' });
              },
            });
          }
      }
      if (keycode === "Enter") {
          toggleDropdown(e);
      }
  };

  if (mobileMenu) {
    const id = 'marines-mobile-menu';
    mobileMenu.setAttribute('id', id);
    // init
    const dropdowns = document.querySelectorAll('#marines-mobile-menu a[data-toggle="submenu"]');
    each([...dropdowns], (item) => {
      const subarrow = document.createElement('span');
      subarrow.classList.add('sub-arrow');
      item.appendChild(subarrow);
      item.setAttribute('data-height', item.nextElementSibling.getBoundingClientRect().height);
      item.addEventListener('click', e => toggleDropdown(e), false);
      item.addEventListener('touch', e => toggleDropdown(e), false);
      item.addEventListener('keydown', e => keyCodeCheck(e), false);
    });
    each([...dropdowns], (item) => {
      item.nextElementSibling.setAttribute('style', 'display: none; max-height: 0; overflow: hidden;');
    });
  }

  function openNav() {
    if (document.body && !document.body.classList.contains('noscroll')) {
      document.body.classList.add('noscroll');
    }
    mobileNav.classList.add('open');
  }

  function closeNav() {
    if (document.body && document.body.classList.contains('noscroll')) {
      document.body.classList.remove('noscroll');
    }
    mobileNav.classList.remove('open');
  }

  let isNavOpen = false;
  buttonOpen.addEventListener('click', (e) => {
    e.preventDefault();
    let element = e.target;
    if (!isNavOpen) {
        isNavOpen = true;
        element.parentNode.setAttribute('aria-expanded', 'true');
      openNav();
    }
  }, false);

  buttonClose.addEventListener('click', (e) => {
    e.preventDefault();
    let element = e.target;
    if (isNavOpen) {
        isNavOpen = false;
        element.parentNode.setAttribute('aria-expanded', 'false');
      closeNav();
    }
  }, false);
}

export function UnitFlagshipNav() {
  const flagNav = document.getElementById('unitflagmenu');
  const flagNavList = document.getElementById('unit-flag-menu-list');
  if (!flagNav) return;

  const toggleDropdown = (e) => {
    e.preventDefault();
    let element = e.target;
    if (!element) return;
    if (element.tagName === 'SPAN' && element.classList.contains('sub-arrow')) {
      const ul = element.parentNode.nextElementSibling;
      if (element.parentNode.getAttribute('aria-expanded') === 'false') {
        element.parentNode.setAttribute('aria-expanded', 'true');
        gsap.set(ul, { display: 'block' });
        gsap.to(ul, 0.25, {
          ease: 'Power4.easeOut',
        });
      } else {
        element.parentNode.setAttribute('aria-expanded', 'false');
        gsap.to(ul, 0.25, {
          ease: 'Power4.easeOut',
          onComplete: () => {
            gsap.set(ul, { display: 'none' });
          },
        });
      }
    } else {
      if (element.tagName === 'SPAN') { element = element.parentNode; }
      const href = element.getAttribute('href');
      if (href && !element.classList.contains('disabled')) {
        window.location = href;
      }
    }
  };

  const keyCodeCheck = (e) => {
      if (!e.target) return;
      let keycode = e.code;
      if (keycode === "Space") {
         e.preventDefault();
         const ul = e.target.nextElementSibling;
         if (e.target.getAttribute('aria-expanded') === 'false') {
            e.target.setAttribute('aria-expanded', 'true');
            gsap.set(ul, { display: 'block' });
            gsap.to(ul, 0.25, {
              ease: 'Power4.easeOut',
            });
          } else {
            e.target.setAttribute('aria-expanded', 'false');
            gsap.to(ul, 0.25, {
              ease: 'Power4.easeOut',
              onComplete: () => {
                gsap.set(ul, { display: 'none' });
              },
            });
          }
      }
      if (keycode === "Enter") {
          toggleDropdown(e);
      }
  };

  if (flagNavList) {
    // init
    const dropdowns = document.querySelectorAll('#unit-flag-menu-list a[data-toggle="submenu"]');
    each([...dropdowns], (item) => {
      item.setAttribute('data-height', item.nextElementSibling.getBoundingClientRect().height);
      item.addEventListener('click', e => toggleDropdown(e), false);
      item.addEventListener('touch', e => toggleDropdown(e), false);
      item.addEventListener('keydown', e => keyCodeCheck(e), false);
    });
  }
}
